import React from 'react';
import { Layout } from 'fronton-react';
import {
  RootLayout,
  HeaderImageStructure,
  HeaderSection,
  OtherSection,
  StagesSection,
  StepsSection,
} from 'common/components';
import { useIsInViewport, useScrollToElement } from 'common/hooks';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import { FloorScreedDesignPanel, FloorScreedTypesSection, FloorScreedAdvantagesSection } from './components';
import {
  FLOOR_SCREED_HEADER_CDN_PATH,
  FLOOR_SCREED_PATH,
  FLOOR_SCREED_ELEMENT_BLOCK,
  FLOOR_SCREED_LANDING_NAME,
  FLOOR_SCREED_STAGES_LIST,
  FLOOR_SCREED_STEPS_LIST,
} from './floor-screed-constants';

/**
 * Вью страницы "Стяжка пола"
 */
export const FloorScreed = () => {
  const { elRef, onScrollToElement } = useScrollToElement();
  const isConsultationFormVisible = useIsInViewport(elRef, { threshold: 0 });

  return (
    <RootLayout currentPage={FLOOR_SCREED_PATH}>
      <HeaderSection
        bgColor="#F2F3F5"
        textColor="text-primary"
        description="Полусухая стяжка&nbsp;&mdash; это технология выравнивания пола перед финишным покрытием. Технология позволяет получить идеально ровную поверхность и&nbsp;сократить время строительных работ. В&nbsp;процессе укладки используется специальное оборудование для&nbsp;приготовления и&nbsp;подачи материала."
        img={
          {
            ldSrcSet: `${FLOOR_SCREED_HEADER_CDN_PATH}/header/header-new-ld.jpg/header-new-ld.jpg`,
            dSrcSet: `${FLOOR_SCREED_HEADER_CDN_PATH}/header/header-new-d.jpg/header-new-d.jpg`,
            tSrcSet: `${FLOOR_SCREED_HEADER_CDN_PATH}/header/header-new-t.jpg/header-new-t.jpg`,
            mSrcSet: `${FLOOR_SCREED_HEADER_CDN_PATH}/header/header-new-m.jpg/header-new-m.jpg`,
            title: 'Полусухая стяжка пола',
            alt: 'Полусухая стяжка пола',
          } as HeaderImageStructure
        }
        title="Полусухая стяжка пола под&nbsp;ключ"
        mediaType="image"
      />
      <FloorScreedDesignPanel
        isConsultationFormVisible={isConsultationFormVisible}
        onConsultationSignupBtnClick={onScrollToElement}
      />
      <Layout>
        <PromoBlock elementBlock={FLOOR_SCREED_ELEMENT_BLOCK} />
        <SpecialOffer onModalBtnClick={onScrollToElement} elementBlock={FLOOR_SCREED_ELEMENT_BLOCK} />
        <FloorScreedTypesSection />
        <FloorScreedAdvantagesSection />
        <StagesSection sectionTitle="Этапы выполнения работ" stages={FLOOR_SCREED_STAGES_LIST} />
        <StepsSection sectionTitle="Как получить готовую стяжку" steps={FLOOR_SCREED_STEPS_LIST} />
        <ConsultationSection
          consultationType="FLOOR_SCREED"
          elementBlock={FLOOR_SCREED_ELEMENT_BLOCK}
          elementText="Заявка на расчёт"
          sectionRef={(el: HTMLElement | null) => {
            elRef.current = el;
          }}
          sectionText="Отправьте заявку, мы&nbsp;перезвоним и&nbsp;бесплатно проконсультируем, а&nbsp;также рассчитаем примерную стоимость."
          sectionTitle="Заявка на&nbsp;расчёт"
        />
      </Layout>
      <OtherSection
        elementBlock={`${FLOOR_SCREED_ELEMENT_BLOCK} / other`}
        landingName={FLOOR_SCREED_LANDING_NAME}
        promotionName={`${FLOOR_SCREED_ELEMENT_BLOCK}_bottom`}
      />
    </RootLayout>
  );
};
